import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute() {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return <div>Loading...</div>; 
    }

    if (user.isAuthenticated === false) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}